import React, { useEffect } from "react";
import "./Modal.scss";
import { useNavigate } from "react-router-dom";
import Drawer from "@mui/material/Drawer";
import { googleEvent_LOJ213 } from "../../lib/google-analytics";

export default function SelfieModal(props) {
  const { openPanModal, setOpenPanModal, selfieAttempt, message } = props;
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpenPanModal(false);
      // if (selfieAttempt >= 1) {
      //   navigate("/dashboard");
      // }
    }, 5000);

    googleEvent_LOJ213();

    return () => clearTimeout(timer);
  }, [selfieAttempt, navigate]);

  return (
    <div>
      <Drawer anchor="bottom" open={openPanModal} onClose={() => setOpenPanModal(false)}>
        <div className="selfie__modal">
          <img src="/images/loader-selfie.gif" alt="Loading animation" />
          <span>
            {selfieAttempt === 0
              ? "Verification failed. Please try again."
              : "Just a moment! Making sure it's really you"}
          </span>

          {selfieAttempt === 0 && <p className="attempt-message success mt-2">Attempt 1 of 2</p>}
          {selfieAttempt >= 1 && <p className="attempt-message error mt-2">Attempt 2 of 2</p>}
        </div>
      </Drawer>
    </div>
  );
}
